var map = {
	"./FF7LevelingCalculator.png": 68,
	"./GithubButton.png": 34,
	"./Graphs.png": 69,
	"./PdfButton.png": 35,
	"./PostmanTestPreview.png": 70,
	"./QualcommLogo.png": 71,
	"./SnJArcHomeDesktop.png": 72,
	"./SymposiumHomeDesktop.png": 73,
	"./WordButton.png": 36,
	"./cityNightLights.png": 24,
	"./cloudsMain.png": 25,
	"./linkedinbutton.png": 37,
	"./myFace.png": 26,
	"./trainStation.png": 27
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23;